module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-3-pod_600px_width-0_1-@1x.5c59f4c8.png";